import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import Layout from "./components/ui/Layout.jsx";
import Toasts from "./components/ui/Toast.jsx";
import Login from "./pages/Login.jsx";
import Dashboard from "./pages/Dashboard.jsx";
import MapPage from "./pages/Map.jsx";
import DeviceDetail from "./pages/DeviceDetail.jsx";
import UserDevicesPage from "./pages/UserDevices.jsx";
import AdminDevicesPage from "./pages/Devices.jsx";
import AdminUsersPage from "./pages/Admin.jsx";
import Settings from "./pages/Settings.jsx";
import AlertsPage from "./pages/Alerts.jsx";
import { useAuthStore } from "./lib/store.js";
import api from "./lib/api.js";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1 },
  },
});

export default function App() {
  const { user, setUser } = useAuthStore();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("me")
      .json()
      .then((data) => setUser(data))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full">
        <div style={{ color: "var(--color-cyan)", fontFamily: "var(--font-mono)", letterSpacing: "0.2em" }}>
          INITIALIZING...
        </div>
      </div>
    );
  }

  return (
    <QueryClientProvider client={queryClient}>
      <Toasts />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={user ? <Navigate to="/" /> : <Login />} />
          <Route
            path="/*"
            element={
              user ? (
                <Layout>
                  <Routes>
                    {/* All users */}
                    <Route path="/"                   element={<MapPage />} />
                    <Route path="/devices"            element={<UserDevicesPage />} />
                    <Route path="/devices/:id"        element={<DeviceDetail />} />
                    <Route path="/alerts"             element={<AlertsPage />} />
                    <Route path="/settings"           element={<Settings />} />

                    {/* Admin only */}
                    <Route path="/dashboard"          element={<Dashboard />} />
                    <Route path="/admin/devices"      element={<AdminDevicesPage />} />
                    <Route path="/admin/users"        element={<AdminUsersPage />} />
                  </Routes>
                </Layout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
